import React, { useEffect, useState } from 'react';
import axios from '../axios.jsx';
import ReactPaginate from 'react-paginate';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import ContactModal from './Modaldir.jsx';
import Swal from 'sweetalert2'

const CompShowalertas = () => {
  const [directorio, setDirectorio] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState('');
  const [pageNumber, setPageNumber] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const blogsPerPage = 10;
  const [usernivel, setusernivel]= useState('');

  const getBlogs = async () => {
    try {
      const res = await axios.get('directorio');
      const reversed = res.data.reverse();
      setDirectorio(reversed);
      setFilteredData(reversed);
    } catch (error) {
      console.error('Error al obtener los datos:', error);
    }
  };

  useEffect(() => {
    getBlogs();
    const nivel = sessionStorage.getItem('usernivel');
    if (nivel) setusernivel(nivel);
  }, []);

  const handleDeleteBlog = (blogId) => {
          Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminarlo'
          }).then((result) => {
            if (result.isConfirmed) {
              // Llamada a la función para eliminar el blog
              deleteBlog(blogId);
        
            }
          });
        };

        const deleteBlog = async (id) => {
           if (usernivel === '1') {
                try {
                    await axios.delete(`directorio/${id}`);
                    getBlogs();
                } catch (error) {
                    console.error(`Error deleting blog with id ${id}:`, error);
                }
                }else {
        Swal.fire({
          icon: 'warning',
          title: 'Acción no permitida',
          text: 'Esta acción solo está permitida para administradores.',
        });
      }
            };
        

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    const filtered = directorio.filter(
      (item) =>
        item.Entidad.toLowerCase().includes(value) ||
        item.oficina.toLowerCase().includes(value) ||
        item.Correo.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
    setPageNumber(0); // Reinicia a la primera página cuando se filtra
  };

  const pageCount = Math.ceil(filteredData.length / blogsPerPage);
  const displayBlogs = filteredData
    .slice(pageNumber * blogsPerPage, (pageNumber + 1) * blogsPerPage)
    .map((blog) => (
      <tr key={blog.id}>
        <td>{blog.Entidad}</td>
        <td>{blog.oficina}</td>
        <td>{blog.Correo}</td>
        <td>{blog.Numero}</td>
        <td>
          <button
            className="btn btn-warning"
            onClick={() => handleEditClick(blog)}
          >
            <i className="fas fa-edit"></i>
          </button>
          <button onClick={() => handleDeleteBlog(blog.id)} className='btn btn-danger'>
            <i className='fas fa-trash-alt'></i>
             </button>
        </td>
      </tr>
    ));

  const handlePageChange = ({ selected }) => setPageNumber(selected);

  const handleEditClick = (contact) => {
   
    setSelectedContact(contact);
    setShowModal(true);
    
  };

  const handleSave = async (updatedContact) => {
    try {
      const contactToSave = {
        ...updatedContact,
        Correo: updatedContact.Correo.toLowerCase(),
      };

      if (selectedContact) {
        await axios.put(`directorio/${selectedContact.id}`, contactToSave);
        getBlogs();
      } else {
        await axios.post('directorio/', contactToSave);
        getBlogs();
      }
      setShowModal(false);
    } catch (error) {
      console.error('Error al guardar el contacto:', error);
    }
  };

  return (
    <div className="container">
      <p className="mt-2">Directorio Sistema de alerta temprana</p>
  <div className="row align-items-center my-3">
    {/* Columna para el botón "Home" */}
    <div className="col-4 text-start">
      <Link to="/app" className="btn btn-outline-secondary">
        <i className="fas fa-home"></i> Home
      </Link>
    </div>

    {/* Columna para el botón "Agregar Contacto" */}
    <div className="col-4 text-center">
      <button
        className="btn btn-primary"
        onClick={() => {
          setSelectedContact(null);
          setShowModal(true);
        }}
      >
        <i className="fas fa-plus"></i> 
      </button>
    </div>

    {/* Columna para la barra de búsqueda */}
    <div className="col-4 text-end">
      <input
        type="text"
        className="form-control form-control-sm w-75 d-inline"
        placeholder="Buscar"
        value={search}
        onChange={handleSearch}
      />
    </div>
  </div>
  


      <div className="table-responsive">
        <table className="table table-striped">
          <thead className="table-primary">
            <tr>
              <th>Entidad</th>
              <th>Oficina</th>
              <th>Correo</th>
              <th>Telefono</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>{displayBlogs}</tbody>
        </table>
      </div>

      <ReactPaginate
        previousLabel={<i className="fas fa-chevron-left"></i>}
        nextLabel={<i className="fas fa-chevron-right"></i>}
        pageCount={pageCount}
        onPageChange={handlePageChange}
        containerClassName={'pagination justify-content-center'}
        pageClassName={'page-item'}
        pageLinkClassName={'page-link'}
        previousClassName={'page-item'}
        previousLinkClassName={'page-link'}
        nextClassName={'page-item'}
        nextLinkClassName={'page-link'}
        disabledClassName={'page-item disabled'}
        activeClassName={'page-item active'}
      />

      <ContactModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleSave={handleSave}
        contact={selectedContact}
      />
    </div>
  );
};

export default CompShowalertas;
